<template>
    <va-modal
      id="sendQrCodeModal"
      ref="sendQrCodeModal" 
      :value="isOpen"
      :okText="$t('modals.buttons.send')"
      :cancelText="$t('modals.buttons.cancel')"
      @cancel="closeModal"
      @ok="sendEmail"
      :okDisabled="!validEmail || form.data.email === '' || isLoading"
      size="small"
      :noOutsideDismiss="true"
    >

      <div slot="header" class="modal-title">
        {{$t('agenda.availabilities.send_qr_code_title')}}
      </div>

      <div class="py-2">
        <span>{{$t('agenda.availabilities.send_qr_code_tip')}}</span>
      </div>

      <div class="py-3">
        <va-input
          id="send-qr-code-email"
          :label="$t('agenda.screenings.email')"
          v-model="form.data.email"
          :error="!validEmail"
          :error-messages="errorMessages"
        />
      </div>

    </va-modal>
</template>
<script>
import { AvailabilityService } from '@/api/BookingService'
import { EMAIL_REGEX } from '@/utils/regex'
export default {
  props: {
    availability: {
      type: Object,
      required: true,
      validator: (availability) => availability.user !== null
    }
  },
  computed: {
    validEmail: function () {
      if (this.form.data.email === '') {
        return true
      } else {
        return this.form.data.email.match(EMAIL_REGEX)
      }
    },
    errorMessages: function () {
      return [
        this.$t('agenda.screenings.qr_code_email_invalid')
      ]
    }
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      form: {
        data: {
          email: this.availability.user ? this.availability.user.email : ''
        }
      }
    }
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    closeModal () {
      this.isOpen = false
      this.$emit('modalClosed')
    },
    sendEmail: function () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      
      this.form.data.email = this.form.data.email.toLowerCase().trim()

      AvailabilityService.sendQRCodeNotification(this.availability.id, this.form.data)
      .then(() => {
        this.showToast(this.$t('agenda.staff_availabilities.qrcode_sent'), this.$store.state.successToastOptions)
        this.closeModal()
      }).catch(err => {
        this.showToast(this.$t('agenda.screenings.something_went_wrong'), this.$store.state.errorToastOptions)
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

